import * as React from 'react';
import { Tab } from 'react-tabs';

import hoistNonReactStatics from 'hoist-non-react-statics';

import { styled } from '../theme';
import TabsMenuLink from './TabsMenuLink';

const TabsMenuItem = styled(TabsMenuLink.withComponent(Tab))<{}>(({ theme }) => ({}));

export default hoistNonReactStatics(TabsMenuItem, Tab);
